import { Component, OnInit, Inject, PLATFORM_ID, TemplateRef } from '@angular/core';
import { Location, DOCUMENT, isPlatformBrowser } from '@angular/common';
import { Router, NavigationEnd, ActivatedRoute } from '@angular/router';
import { Title } from '@angular/platform-browser';

// ** rxjs
import { filter, map, take } from 'rxjs/operators';

// ** service
import { LayoutService } from './core/services/layout.service';

//  ** env
import { environment } from '@env/environment';

import * as AOS from 'aos';
import { PrimeNGConfig } from 'primeng/api';

@Component({
	selector: 'app-root',
	templateUrl: './app.component.html',
	styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {
	isBrowser = false;
	public loadingTemplate!: TemplateRef<any>;

	constructor(
		public location: Location,
		private primengConfig: PrimeNGConfig,
		private router: Router,
		private titleService: Title,
		public layoutService: LayoutService,
		@Inject(DOCUMENT) private document: Document,
		@Inject(PLATFORM_ID) private platformId
	) {
		this.isBrowser = isPlatformBrowser(this.platformId);
		if (this.isBrowser) window.addEventListener('scroll', (e) => this.onWindowScroll(e));
		this.titleDynamic();
		this.revealPageAfterFirstNavigation();
	}

	onWindowScroll(e) {
		if (window.scrollY > 30) {
			const element = this.document.getElementById('navbar-top');
			if (element) {
				element?.classList.remove('navbar-transparent');
				element?.classList.add('bg-blue');
			}
		} else {
			const element = this.document.getElementById('navbar-top');
			if (element) {
				element?.classList.add('navbar-transparent');
				element?.classList.remove('bg-blue');
			}
		}
	}
	ngOnInit() {
		this.primengConfig.ripple = false;
		this.primengConfig.setTranslation({
			accept: '確認',
			reject: '取消',
			dayNames: ['日', '一', '二', '三', '四', '五', '六'],
			dayNamesShort: ['日', '一', '二', '三', '四', '五', '六'],
			dayNamesMin: ['日', '一', '二', '三', '四', '五', '六'],
			monthNames: [
				'一月',
				'二月',
				'三月',
				'四月',
				'五月',
				'六月',
				'七月',
				'八月',
				'九月',
				'十月',
				'十一月',
				'十二月',
			],
			monthNamesShort: [
				'一月',
				'二月',
				'三月',
				'四月',
				'五月',
				'六月',
				'七月',
				'八月',
				'九月',
				'十月',
				'十一月',
				'十二月',
			],
			today: '今天',
			clear: '清除',
			weekHeader: 'Wk',
			// 參數
			// startsWith: 'Starts with',
			// contains: 'Contains',
			// notContains: 'Not contains',
			// endsWith: 'Ends with',
			// equals: 'Equals',
			// notEquals: 'Not equals',
			// noFilter: 'No Filter',
			// lt: 'Less than',
			// lte: 'Less than or equal to',
			// gt: 'Greater than',
			// gte: 'Greater than or equal to',
			// is: 'Is',
			// isNot: 'Is not',
			// before: 'Before',
			// after: 'After',
			// dateIs: 'Date is',
			// dateIsNot: 'Date is not',
			// dateBefore: 'Date is before',
			// dateAfter: 'Date is after',
			// clear: 'Clear',
			// apply: 'Apply',
			// matchAll: 'Match All',
			// matchAny: 'Match Any',
			// addRule: 'Add Rule',
			// removeRule: 'Remove Rule',
			// accept: 'Yes',
			// reject: 'No',
			// choose: 'Choose',
			// upload: 'Upload',
			// cancel: 'Cancel',
			// dayNames: [
			// 	'Sunday',
			// 	'Monday',
			// 	'Tuesday',
			// 	'Wednesday',
			// 	'Thursday',
			// 	'Friday',
			// 	'Saturday',
			// ],
			// dayNamesShort: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
			// dayNamesMin: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
			// monthNames: [
			// 	'January',
			// 	'February',
			// 	'March',
			// 	'April',
			// 	'May',
			// 	'June',
			// 	'July',
			// 	'August',
			// 	'September',
			// 	'October',
			// 	'November',
			// 	'December',
			// ],
			// monthNamesShort: [
			// 	'Jan',
			// 	'Feb',
			// 	'Mar',
			// 	'Apr',
			// 	'May',
			// 	'Jun',
			// 	'Jul',
			// 	'Aug',
			// 	'Sep',
			// 	'Oct',
			// 	'Nov',
			// 	'Dec',
			// ],
			// dateFormat: 'mm/dd/yy',
			// firstDayOfWeek: 0,
			// today: 'Today',
			// weekHeader: 'Wk',
			// weak: 'Weak',
			// medium: 'Medium',
			// strong: 'Strong',
			// passwordPrompt: 'Enter a password',
			// emptyMessage: 'No results found',
			// emptyFilterMessage: 'No results found',
		});

		if (this.isBrowser) {
			this.onWindowScroll(event);
			AOS.init();
		}
	}

	titleDynamic() {
		this.router.events
			.pipe(
				filter((event) => event instanceof NavigationEnd),
				map(() => {
					let route: ActivatedRoute = this.router.routerState.root;
					let routeTitle = '';
					while (route!.firstChild) route = route.firstChild;
					if (route.snapshot.data['title']) routeTitle = route!.snapshot.data['title'];
					return routeTitle;
				})
			)
			.subscribe((title: string) => {
				if (title) this.titleService.setTitle(`${environment.projectTitleCH} - ${title}`);
			});
	}

	// 搭配 index.html 的 GitHub Pages 404 還原腳本：
	// 如果進站前有被藏起來 (從 404 導回來、避免烤好的首頁畫面閃一下)，
	// 等 Router 第一次定位完成 (已經是還原後的正確路由) 再把畫面顯示出來。
	revealPageAfterFirstNavigation() {
		if (!this.isBrowser) return;
		this.router.events
			.pipe(
				filter((event) => event instanceof NavigationEnd),
				take(1)
			)
			.subscribe(() => {
				this.document.documentElement.style.visibility = '';
			});
	}
}
